<template>
  <b-modal id="status-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Contract Classification</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Employment Category</label>
                <div class="col-md-8 mb-3">
                  {{detail.employcat_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Type of Contract</label>
                <div class="col-md-8 mb-3">
                  {{detail.workpertype_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Contract Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status == 1 ? "Active":"Not Active"}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_until}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_from}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Update</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_update}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "EmployeeStatusDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    id:{
      type:Number
    }
  },
  data(){
    return {
      detail:{
        type_name:"",
        employcat_name:"",
        workpertype_name:"",
        status:"",
        valid_from:"",
        valid_until:"",
        last_update:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        AxiosCall.Get({},urlApi.contract_classification.detail+"/"+this.id ).then(res=>{
          if (res.success){
            this.detail = res.atributes
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }, 100)
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    successMessage(title)
    {
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    resetModal(){
      this.detail = {
        type_name:"",
        employcat_name:"",
        workpertype_name:"",
        status:"",
        valid_from:"",
        valid_until:"",
        last_update:""
      }
      this.$parent.id = null
      this.$refs.modal.hide()
    }
  }
}
</script>